/**
 * Evaluate route meta feature-flag rules against a snapshot of flag values (e.g. Vuex).
 *
 * @param {{ featureFlagKey?: string, featureFlagInvert?: boolean, featureFlagKeysAny?: string[] }|undefined} meta
 * @param {Record<string, boolean>} values flag key -> on/off
 * @returns {boolean}
 */
export function evaluateRouteMeta(meta, values) {
  if (!meta) {
    return true
  }
  if (meta.featureFlagKeysAny && meta.featureFlagKeysAny.length) {
    const raw = meta.featureFlagKeysAny.some((key) => Boolean(values[key]))
    return meta.featureFlagInvert ? !raw : raw
  }
  if (meta.featureFlagKey) {
    const raw = Boolean(values[meta.featureFlagKey])
    return meta.featureFlagInvert ? !raw : raw
  }
  return true
}
